export const CONFLUENCE_PRODUCT_ID = 'confluence';
export const NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
export const INPUT_DEBOUNCE_TIME = 250;
export const SPACE_FILTER_LIMIT = 10;
export const PEOPLE_FILTER_LIMIT = 10;
export let ConfluenceFilters = /*#__PURE__*/function (ConfluenceFilters) {
  ConfluenceFilters["Space"] = "spaces";
  ConfluenceFilters["People"] = "contributors";
  ConfluenceFilters["Date"] = "lastModified";
  return ConfluenceFilters;
}({});
export let ConfluenceScope = /*#__PURE__*/function (ConfluenceScope) {
  ConfluenceScope["Item"] = "confluence.page,blogpost,attachment";
  ConfluenceScope["Space"] = "confluence.space";
  ConfluenceScope["People"] = "urs.user-confluence";
  ConfluenceScope["Content"] = "confluence.page,blogpost,attachment,whiteboard";
  return ConfluenceScope;
}({});